/* eslint-disable import/prefer-default-export */
import React from "react";
import { MBAThemeProvider, primaryTheme } from "@muchbetteradventures/styleguide";

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(MBAThemeProvider, {
    theme: theme || primaryTheme
  }, children);
};

export { ThemeProvider };